'use client';

import { useEffect, useRef, useState } from 'react';
import { usePathname } from 'next/navigation';

import LoadingOverlay from './LoadingOverlay';
import { useSelector } from 'react-redux';
import { RootState } from '@/app/store/store';

export default function LoaderOverlayTransition() {
  const isAppLoading = useSelector<RootState, boolean>(
    (state: RootState) => state.reparoly.isAppLoading === true,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [routeChanging, setRouteChanging] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const pathname = usePathname();

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);

    setRouteChanging(true);
    timerRef.current = setTimeout(() => setRouteChanging(false), 1000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [pathname]);

  // useEffect(() => {
  //   console.log("Hola")
  //   setIsLoading(false);

  //   dispatch(setIsLoadingReparoly({ value: false }));

  //   window.scrollTo({ top: 0, behavior: 'smooth' });
  //   return () => {
  //     console.log("true")
  //     //if (timerRef.current) clearTimeout(timerRef.current);
  //   };
  // }, [dispatch, pathname]);

  useEffect(() => {
    const handleStart = () => setIsLoading(true);
    // const handleComplete = () => setIsLoading(false);

    // Escuchar eventos de navegacion
    window.addEventListener('beforeunload', handleStart);

    return () => {
      window.removeEventListener('beforeunload', handleStart);
    };
  }, []);

  const show = isLoading || routeChanging;

  return (
    <>
      {show && <LoadingOverlay />}
      {isAppLoading && <LoadingOverlay />}
      {/* {children} */}
    </>
  );
}
